import { useState } from 'react';
import { wt } from '../lib/copy.ts';
import { Button } from './ui.tsx';

/**
 * FB-001 / FB-002: change a lift's weight right here, with − / + (2.5 kg or 5 lb) instead of the keyboard. It writes
 * the built-in programme's target_overridden or a plan's plan_weight_set (ADR-0025); the caller decides which.
 */
export function WeightEdit({ name, weight, unit, min, onSave }: { name: string; weight: number; unit: 'kg' | 'lb'; min: number; onSave: (w: number) => void }) {
  const [w, setW] = useState<number | null>(null);
  const step = unit === 'kg' ? 250 : 500;
  if (w === null)
    return (
      <button type="button" className="text-sm text-text-muted underline min-h-11 px-1" aria-label={`Change ${name} weight`} onClick={() => setW(weight)}>
        Change weight
      </button>
    );
  return (
    <div className="mt-2 flex flex-wrap items-center justify-between gap-2" role="group" aria-label={`Change ${name} weight`}>
      <span className="flex items-center gap-2">
        <button type="button" className="min-w-11 min-h-11 rounded-full border border-outline" aria-label="Lower" onClick={() => setW(Math.max(min, w - step))}>
          −
        </button>
        <span className="num text-headline w-20 text-center">{wt(w, unit)}</span>
        <button type="button" className="min-w-11 min-h-11 rounded-full border border-outline" aria-label="Raise" onClick={() => setW(w + step)}>
          +
        </button>
      </span>
      <span className="flex flex-wrap gap-1">
        <Button kind="text" onClick={() => setW(null)}>
          Cancel
        </Button>
        <Button kind="secondary" disabled={w === weight} onClick={() => (onSave(w), setW(null))}>
          Use it
        </Button>
      </span>
    </div>
  );
}
